import { SYSTEM_HELP } from '@confluence/web-item-location/entry-points/webFragmentLocations.ts';
import { preloadWebItemLocation } from '@confluence/web-item-location/entry-points/preloadWebItemLocation.ts';
import { HelpPanelQuery } from '@confluence/in-product-help/entry-points/HelpPanelQuery.graphql.ts';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

export const preloadHelpMenu = () => {
	return waitForAllReturnWhenError([
		preloadWebItemLocation({ location: SYSTEM_HELP }),
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query({ query: HelpPanelQuery }),
	]);
};
